var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrgChartFalcomHoldingAr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 720,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1280,
    height: 720
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1280,
    height: 720,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.0533333 72.9922",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 836.5 307.492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.5 205.5 767.5 205.5 767.5 236.5 661.5 236.5 661.5 205.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    direction: "rtl",
    writingMode: "rl-tb",
    transform: "translate(669.599 224)",
    x: 89.6667
  }, "\u0644\u062C\u0646\u0629 \u0627\u0644\u062A\u0631\u0634\u064A\u062D\u0627\u062A \u0648\u0627\u0644\u0645\u0643\u0627\u0641\u0622\u062A"), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 700,
    fontSize: 20,
    transform: "translate(56.1712 143)"
  }, "FALCOM Holding Organization Structure "), /*#__PURE__*/React.createElement("path", {
    d: "M946.5 278.5 946.5 356.388",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    strokeDasharray: "1.33333 1.33333",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.5 356.5 947.446 356.5",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    strokeDasharray: "1.33333 1.33333",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.000104987 17.3328",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 711.5 205.833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.5 205.5 618.5 205.5 618.5 235.5 519.5 235.5 519.5 205.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    direction: "rtl",
    writingMode: "rl-tb",
    transform: "translate(524.316 223)",
    x: 89.1667
  }, "\u0644\u062C\u0646\u0629 \u0627\u0644\u062A\u062E\u0637\u064A\u0637 \u0627\u0644\u0627\u0633\u062A\u0631\u0627\u062A\u064A\u062C\u064A"), /*#__PURE__*/React.createElement("path", {
    d: "M567.5 203.819 567.5 188.5",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.000104987 203.555",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 629.5 306.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.5 401.5 415.5 418.382",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.5 204.5 506.5 204.5 506.5 235.5 436.5 235.5 436.5 204.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    direction: "rtl",
    writingMode: "rl-tb",
    transform: "translate(447.244 223)",
    x: 47.3333
  }, "\u0627\u0644\u0644\u062C\u0646\u0629 \u0627\u0644\u062A\u0646\u0641\u064A\u0630\u064A\u0629"), /*#__PURE__*/React.createElement("path", {
    d: "M471.5 204.264 471.5 188.5",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.5 417.5 667.5 417.5 667.5 444.5 590.5 444.5 590.5 417.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    direction: "rtl",
    writingMode: "rl-tb",
    transform: "translate(602.952 434)",
    x: 51.3333
  }, "\u0627\u0644\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A\u0629"), /*#__PURE__*/React.createElement("path", {
    d: "M785.5 483.5 941.5 483.5 941.5 509.5 785.5 509.5 785.5 483.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    direction: "rtl",
    writingMode: "rl-tb",
    transform: "translate(794.952 499)",
    x: 135.167
  }, "\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0645\u0648\u0627\u0631\u062F \u0627\u0644\u0628\u0634\u0631\u064A\u0629 \u0648\u0627\u0644\u062E\u062F\u0645\u0627\u062A \u0627\u0644\u0625\u062F\u0627\u0631\u064A\u0629"), /*#__PURE__*/React.createElement("path", {
    d: "M968.5 483.5 1043.5 483.5 1043.5 510.5 968.5 510.5 968.5 483.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    direction: "rtl",
    writingMode: "rl-tb",
    transform: "translate(983.092 500)",
    x: 44.8333
  }, "\u0627\u0644\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0645\u0627\u0644\u064A\u0629"), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.0151181 25.7869",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 866.5 473.287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.5 471.5 1005.51 472.798",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.5 472.5 1005.5 483.06",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.5 470.5 714.5 481.06",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.5 482.5 753.5 482.5 753.5 509.5 676.5 509.5 676.5 482.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    direction: "rtl",
    writingMode: "rl-tb",
    transform: "translate(679.016 499)",
    x: 70.8333
  }, "\u0625\u062F\u0627\u0631\u0629 \u062A\u0642\u0646\u064A\u0629 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A"), /*#__PURE__*/React.createElement("path", {
    d: "M326.5 205.5 415.5 205.5 415.5 232.5 326.5 232.5 326.5 205.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    direction: "rtl",
    writingMode: "rl-tb",
    transform: "translate(336.896 222)",
    x: 66.8333
  }, "\u0623\u0645\u0627\u0646\u0629 \u0627\u0644\u0647\u064A\u0626\u0629 \u0627\u0644\u0634\u0631\u0639\u064A\u0629"), /*#__PURE__*/React.createElement("path", {
    d: "M369.5 189.5 369.5 204.594",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.5 419.5 901.5 419.5 901.5 446.5 825.5 446.5 825.5 419.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    direction: "rtl",
    writingMode: "rl-tb",
    transform: "translate(841.568 435)",
    x: 42.5
  }, "\u0627\u0644\u0645\u062F\u064A\u0631 \u0627\u0644\u0645\u0627\u0644\u064A"), /*#__PURE__*/React.createElement("path", {
    d: "M335.5 418.5 496.5 418.5 496.5 443.5 335.5 443.5 335.5 418.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 12,
    direction: "rtl",
    writingMode: "rl-tb",
    transform: "translate(368.23 434)",
    x: 93.6667
  }, "\u0648\u062D\u062F\u0629 \u0627\u0644\u062A\u062D\u0644\u064A\u0644 \u0627\u0644\u0627\u0633\u062A\u062B\u0645\u0627\u0631\u064A"), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 103.862 0.000104987",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    strokeDasharray: "1.33333 1.33333",
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 793.362 319.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.5 472.5 866.5 483.06",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.5 305.5 880.5 305.5 880.5 333.5 793.5 333.5 793.5 305.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    direction: "rtl",
    writingMode: "rl-tb",
    transform: "translate(811.605 322)",
    x: 49.6667
  }, "\u0627\u0644\u062A\u062F\u0642\u064A\u0642 \u0627\u0644\u062F\u0627\u062E\u0644\u064A"), /*#__PURE__*/React.createElement("path", {
    d: "M785.5 205.5 892.5 205.5 892.5 235.5 785.5 235.5 785.5 205.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    direction: "rtl",
    writingMode: "rl-tb",
    transform: "translate(814.806 223)",
    x: 47.1667
  }, "\u0644\u062C\u0646\u0629 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629"), /*#__PURE__*/React.createElement("path", {
    d: "M891.5 251.5 999.5 251.5 999.5 278.5 891.5 278.5 891.5 251.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    direction: "rtl",
    writingMode: "rl-tb",
    transform: "translate(922.234 268)",
    x: 46.1667
  }, "\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u062D\u0648\u0643\u0645\u0629"), /*#__PURE__*/React.createElement("path", {
    d: "M395.5 53.5001 872.5 53.5001 872.5 102.5 395.5 102.5 395.5 53.5001Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#F77921",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 29,
    direction: "rtl",
    writingMode: "rl-tb",
    transform: "translate(570.336 86)",
    x: 125.833
  }, "\u0645\u062C\u0644\u0633 \u0627\u0644\u0625\u062F\u0627\u0631\u0629"), /*#__PURE__*/React.createElement("path", {
    d: "M295.5 305.5 358.5 305.5 358.5 333.5 295.5 333.5 295.5 305.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    direction: "rtl",
    writingMode: "rl-tb",
    transform: "translate(308.271 322)",
    x: 36.3333
  }, "\u0627\u0644\u0633\u0643\u0631\u062A\u0627\u0631\u064A\u0629"), /*#__PURE__*/React.createElement("path", {
    d: "M568.5 306.5 689.5 306.5 689.5 333.5 568.5 333.5 568.5 306.5Z",
    stroke: "#528CC1",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#1E2945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 11,
    direction: "rtl",
    writingMode: "rl-tb",
    transform: "translate(602.452 322)",
    x: 52.3333
  }, "\u0627\u0644\u0631\u0626\u064A\u0633 \u0627\u0644\u062A\u0646\u0641\u064A\u0630\u064A"), /*#__PURE__*/React.createElement("path", {
    d: "M676.5 333.5 676.5 356.832",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    strokeDasharray: "1.33333 1.33333",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 576.716 0.934383",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 368.5 189.434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.000104987 17.3328",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 837.5 204.833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.000104987 65.123",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 945.5 252.623)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.5 401.5 866.421 401.673",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.5 306.48 312.5 78.5",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 0.000104987 68.3842",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 629.5 401.884)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.5 399.5 629.5 416.382",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.5 400.5 865.5 417.382",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.5 78.5001 395.253 78.5002",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.5 321.5 568.157 321.5",
    stroke: "#5B9BD5",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgChartFalcomHoldingAr);
export default __webpack_public_path__ + "static/media/org_chart_falcom_holding_ar.3d41948f4dba7c75c38b2066f5a5a1da.svg";
export { ForwardRef as ReactComponent };